import { gql } from '@apollo/client';

const CREATE_CUSTOM_TEACHING_ORDER = gql`
  mutation ($data: CustomTeachingOrderCreateInput!) {
    createCustomTeachingOrder(data: $data) {
      id
      characters {
        id
        character
        characterType
        characterCase
      }
    }
  }
`;

export default CREATE_CUSTOM_TEACHING_ORDER;
